import { render, staticRenderFns } from "./artist-legal-links.vue?vue&type=template&id=5e0cca4a"
import script from "./artist-legal-links.vue?vue&type=script&lang=js"
export * from "./artist-legal-links.vue?vue&type=script&lang=js"
import style0 from "./artist-legal-links.vue?vue&type=style&index=0&id=5e0cca4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./artist-legal-links.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports